import React, { useEffect, useState } from 'react';
import { Button, Table, Modal, ButtonGroup } from 'react-bootstrap';
import { FaSearch, FaTrash } from 'react-icons/fa';
import ModalReserva from './ModalReserva';
import * as api from '~/Services/Service';
import AuthStorage from '~/Utils/AuthStorage';
import { toast } from 'react-toastify';
import { format } from '~/Utils/Helpers';
import {
  DATETIME_DEFAULT_SHORT_FORMAT,
  DATETIME_DEFAULT_SUPER_SHORT_FORMAT,
  EMPREENDIMENTO_LANCAMENTO,
} from '~/constant';

const LotesVendas = ({
  ativosReservados,
  atualizarReservados,
  atualizarMapa,
  ativos,
  setAtivosFiltrados,
}) => {
  const [mostrarModal, setMostrarModal] = useState(null);
  const [mostrarModalConfirmacao, setMostrarModalConfirmacao] = useState(false);
  const [ativoSelecionado, setAtivoSelecionado] = useState(false);
  const [prospectoAtual, setProspectoAtual] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const prospecto = ativosReservados.find(
      reserva => reserva.codigo_prospecto != null
    );
    setProspectoAtual(prospecto);
  }, [ativosReservados]);

  const handleClickVenda1 = () => {
    window.location.href = `/vendas/prospecto/${prospectoAtual.codigo_prospecto}/empreendimento/${lancamentoAtual}`;
  };

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const response = await api.excluirReserva(ativoSelecionado.codigo);
      toast.success(response.message);
      atualizarMapa();
      atualizarReservados();
      setMostrarModalConfirmacao(false);
    } catch (error) {
      toast.error(error);
      setMostrarModalConfirmacao(false);
    } finally {
      setIsLoading(false);
    }
  };

  const confirmarExclusao = id => {
    atualizarMapa();
    const ativo = ativos.find(imovel => imovel.codigo === id);
    setAtivoSelecionado(ativo);
    setMostrarModalConfirmacao(true);
  };

  const pesquisarAtivo = id => {
    atualizarMapa();
    const ativo = ativos.find(a => a.codigo === id);
    setAtivoSelecionado(ativo);
    setMostrarModal(true);
    setAtivosFiltrados([]);
  };

  const lancamentoAtual =
    (AuthStorage.getUser() && AuthStorage.getUser().empreendimento_lancamento) ||
    EMPREENDIMENTO_LANCAMENTO;
  const temFamilia1 =
    ativosReservados &&
    ativosReservados.some(reserva => reserva.codigo_empreendimento === lancamentoAtual);

  return (
    <>
      <div>
        <div
          style={{
            borderRadius: '7px',
            overflow: 'hidden',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              maxHeight: '550px',
              overflowY: 'auto',
              flexGrow: 1,
            }}
          >
            <Table
              striped
              bordered
              responsive
              className="mb-0 table-sm text-center"
            >
              <thead
                style={{
                  position: 'sticky',
                  top: 0,
                  background: '#0747a6',
                  zIndex: 1,
                  backgroundColor: '#0747a6',
                  color: '#fff',
                }}
              >
                <tr>
                  <th>QD</th>
                  <th>LT</th>
                  <th>Prosp.</th>
                  <th>Validade</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                {ativosReservados.length > 0 ? (
                  ativosReservados.map((reserva, index) => (
                    <tr
                      key={index}
                      style={{
                        background: 'white',
                      }}
                      title={
                        reserva.observacao_reserva
                          ? `Observação: ${reserva.observacao_reserva}`
                          : undefined
                      }
                    >
                      <td>{reserva.mapa1}</td>
                      <td>{reserva.mapa2}</td>
                      <td>{reserva.codigo_prospecto}</td>
                      <td>
                        {format.date(
                          reserva.data_vencimento,
                          DATETIME_DEFAULT_SUPER_SHORT_FORMAT
                        )}
                      </td>
                      <td>
                        <ButtonGroup size="sm" role="group">
                          <Button
                            variant="danger"
                            className="ml-1"
                            onClick={() =>
                              confirmarExclusao(reserva.codigo_ativo)
                            }
                          >
                            <FaTrash />
                          </Button>
                          <Button
                            variant="primary"
                            onClick={() => pesquisarAtivo(reserva.codigo_ativo)}
                          >
                            <FaSearch />
                          </Button>
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      Sem lotes reservados
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          <div
            style={{
              display: 'flex',
              padding: '2px',
              justifyContent: 'end',
              marginTop: '7px',
            }}
          >
            {temFamilia1 && (!AuthStorage.isADM() || AuthStorage.isAtendenteLancamento()) && (
              <Button
                onClick={handleClickVenda1}
                variant="primary"
                className="mb-3"
              >
                Iniciar venda
              </Button>
            )}
          </div>
        </div>

        {ativoSelecionado && (
          <Modal
            show={mostrarModalConfirmacao}
            onHide={() => setMostrarModalConfirmacao(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Cancelamento da reserva</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Tem certeza de que deseja excluir a reserva?</p>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '8px',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                }}
              >
                <small>
                  Id: <strong>{ativoSelecionado.codigo}</strong>
                </small>
                <small>
                  Nome: <strong> {ativoSelecionado.nome_familia}</strong>
                </small>
                <small>
                  Quadra: <strong>{ativoSelecionado.quadra}</strong>
                </small>
                <small>
                  Lote: <strong>{ativoSelecionado.lote}</strong>
                </small>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: '8px',
                  flexWrap: 'wrap',
                  marginTop: '8px',
                  justifyContent: 'space-between',
                }}
              >
                <small>
                  Reservado:{' '}
                  <strong>
                    {format.date(
                      ativoSelecionado.data_reserva,
                      DATETIME_DEFAULT_SHORT_FORMAT
                    )}
                  </strong>
                </small>
                <small>
                  Vencimento:{' '}
                  {format.date(
                    ativoSelecionado.data_validade,
                    DATETIME_DEFAULT_SHORT_FORMAT
                  )}
                </small>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setMostrarModalConfirmacao(false)}
              >
                Não
              </Button>
              <Button
                variant="danger"
                disabled={isLoading}
                onClick={handleDelete}
              >
                {isLoading ? <>Excluindo...</> : <>Sim</>}
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {ativoSelecionado && (
          <ModalReserva
            mostrarModal={mostrarModal}
            setMostrarModal={setMostrarModal}
            ativo={ativoSelecionado}
            atualizarReservados={atualizarReservados}
            atualizarMapa={atualizarMapa}
          />
        )}
      </div>
    </>
  );
};

export default LotesVendas;
